/*
  Сумма в поле ввода (20.10.2026): человек пишет «3100,50», сервер ждёт «3100.50».

  Число не превращается в `Number`: деньги на границе остаются строкой, и копейка не
  теряется на округлении. Проверка здесь только формы записи; правила («не больше
  долга», «не ноль») остаются за сервером и приходят словами.
*/

const MONEY_PATTERN = /^\d{1,12}([.,]\d{1,2})?$/

/* Пробелы между разрядами («1 000,50», в том числе неразрывные из копирования)
   убираются (21.10.2026, ревью): так пишут суммы в квитанциях, а кнопка просто
   оставалась выключенной без объяснения. */
function compact(text) {
  // `\s` в JavaScript покрывает и неразрывный (U+00A0), и узкий неразрывный (U+202F) пробелы.
  return String(text).replace(/\s/g, '')
}

export function isMoney(text) {
  return MONEY_PATTERN.test(compact(text))
}

export function asDecimal(text) {
  return compact(text).replace(',', '.')
}

/* Одна ли это сумма, как бы она ни была записана (ревью 30.10.2026): «7100», «7100,00» и
   «7 100.0» - одно и то же. Сравнение текстом после замены запятой считало «7100» и
   «7100.00» разными, и правка начисления из 1С без изменения делала строку «ручной».
   Неверная запись сравнивается как есть: её всё равно не примет `isMoney`. */
export function sameAmount(left, right) {
  return canonical(left) === canonical(right)
}

function canonical(text) {
  const plain = asDecimal(text === '' ? '0' : text)
  if (!MONEY_PATTERN.test(plain)) return plain
  const [whole, part = ''] = plain.split('.')
  return `${whole.replace(/^0+(?=\d)/, '')}.${part.padEnd(2, '0')}`
}

/* Сумма с сервера в поле правки (28.10.2026, аудит 5.4): «7100.00» с точкой читалось как
   чужая запись, а человек пишет и читает «7100,00». Обратно её разберёт `asDecimal`. */
export function asInput(text) {
  return String(text ?? '').replace('.', ',')
}
